import { combineEpics } from 'redux-observable'
import * as starter from './starter'
import * as calculator from './calculator'

export const rootEpic = combineEpics(
  starter.loadingEpic,
  calculator.calculationEpic
)
